import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from 'src/app/components/services/auth/authentication.service';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	isAdmin?: boolean;
	isBusiness?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnInit {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window,
	private authService: AuthenticationService
	) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}
	
	ngOnInit() {
		
	}
	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
		
	}
	MENUITEMS: Menu[] =[
		{
			title: 'Inicio', path: '/inicio', icon: 'home', type: 'link', active: false
		},
		{
			title: 'Mi municipio', type: 'label'
		},
		{
			title: 'Mi municipio', path: '/sistema/configuracion', icon: 'flag', type: 'link', active: false
		},
		{
			title: 'Sistema', icon: 'settings', type: 'sub', active: false, children: [
				{ path: '/sistema/personalizacion', title: 'Personalización', type: 'link' },
				{ path: '/sistema/variables', title: 'Variables de sistema', type: 'link' },
				{ path: '/sistema/integraciones-pago', title: 'Integraciones de pago', type: 'link' },
			]
		},
		{
			title: 'Seguridad', icon: 'shield', type: 'sub', active: false, children: [
				{ path: '/seguridad/areas',    title: 'Áreas',    type: 'link' },
				{ path: '/seguridad/perfiles', title: 'Perfiles', type: 'link' },
				{ path: '/seguridad/modulos',  title: 'Módulos',  type: 'link' },
			]
		},
		{
			title: 'Catálogos', icon: 'list', type: 'sub', active: false, children: [
				{ path: '/catalogs/dependencias', title: 'Dependencias', type: 'link' },
				{ path: '/catalogs/tipos-documento', title: 'Tipos de documento', type: 'link' },
				{ path: '/catalogs/codigos-scian', title: 'Códigos SCIAN', type: 'link' },
				{ path: '/catalogs/reportes', title: 'Reportes', type: 'link' },
				{ path: '/catalogs/turnos', title: 'Turnos', type: 'link' },
			]
		},
		{
			title: 'Atención ciudadana', type: 'label'
		},
		{
			title: 'Dashboard', path: '/dashboard', icon: 'grid', type: 'link', active: false
		},
		{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reportes/nuevo', title: 'Nuevo reporte', type: 'link'},
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'},
				{path: '/reports/mapa', title: 'Mapa', type: 'link'}
			]
		},
		{
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},
		{
			title: 'Trámites y servicios', type: 'label'
		},
		{
			title: 'Configuración', path: '/tramites/configuracion', icon: 'sliders', type: 'link', active: false
		},
		{
			title: 'Catálogo', path: '/tramites/catalogo', icon: 'file-text', type: 'link', active: false
		},
		{
			title: 'Solicitudes', path: '/tramites/solicitudes', icon: 'inbox', type: 'link', active: false
		},
		{
			title: 'Catastro', type: 'label'
		},
		{
			title: 'Predios', path: '/catastro/predios', icon: 'layers', type: 'link', active: false
		},
		{
			title: 'Pagos', path: '/catastro/pagos', icon: 'credit-card', type: 'link', active: false
		},
		{
			title: 'Limpia pública', type: 'label'
		},
		{
			title: 'Dashboard', path: '/limpia-publica/dashboard', icon: 'activity', type: 'link', active: false
		},
		{
			title: 'Monitor', path: '/limpia-publica/monitor', icon: 'map', type: 'link', active: false
		},
		{
			title: 'Unidades', path: '/limpia-publica/unidades', icon: 'truck', type: 'link', active: false
		},
		{
			title: 'Rutas', path: '/limpia-publica/rutas', icon: 'navigation', type: 'link', active: false
		},
		{
			title: 'Turnos', path: '/limpia-publica/turnos', icon: 'clock', type: 'link', active: false
		},
		{
			title: 'Programación', path: '/limpia-publica/programacion', icon: 'calendar', type: 'link', active: false
		},
		{
			title: 'Suscripciones', path: '/limpia-publica/suscripciones', icon: 'bell', type: 'link', active: false
		},
		{
			title: 'Bitácora', path: '/limpia-publica/bitacora', icon: 'book-open', type: 'link', active: false
		},
		{
			title: 'Notificaciones', path: '/limpia-publica/notificaciones', icon: 'message-square', type: 'link', active: false
		},
		{
			title: 'Bolsa de trabajo', type: 'label'
		},
		{
			title: 'Empresas', path: '/jobs/companies', icon: 'briefcase', type: 'link', active: false
		},
		{
			title: 'Vacantes', path: '/jobs', icon: 'search', type: 'link', active: false
		},
	];
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

	/*Menú User*/
	MENUITEMSUSER: Menu[] =[
		{
			title: 'Inicio', path: '/menus', icon: 'menu', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Mis reportes', path: '/reports/my-user-reports', icon: 'monitor', type: 'link', badgeType: 'primary', active: false
		},
		// {
		// 	title: 'Agregar reporte', path: '/reports/my-user-reports/create-report', icon: 'clipboard', type: 'link', badgeType: 'primary', active: false
		// },
		// {
		// 	title: 'Mis viajes', path: '/trips/my-trips', icon: 'map', type: 'link', badgeType: 'primary', active: false
		// },
	]
	itemsUser = new BehaviorSubject<Menu[]>(this.MENUITEMSUSER);


	/*Menu Área*/
	MENUAREA: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Mis reportes', path: '/reports/my-area-reports', icon: 'monitor', type: 'link', badgeType: 'primary', active: false
		},
		// {
		// 	title: 'Ordenes de trabajo', path: '/work-orders', icon: 'clipboard', type: 'link', badgeType: 'primary', active: false
		// },
	]
	itemsArea = new BehaviorSubject<Menu[]>(this.MENUAREA);

	/*Menu Supervisor*/
	MENUSUPERVISOR: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		/*{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'}
			]
		},*/
		/*{
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},*/
	]
	itemsSupervisor = new BehaviorSubject<Menu[]>(this.MENUSUPERVISOR);

	/*Menú SuperAdmin*/
	MENUSUPERADMIN: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		/*{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'}
			]
		},*/
		/*{
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},*/
		{
			title: 'Usuarios', icon: 'user-plus', type: 'sub', active: false, children: [
				{ path: '/users', title: 'Ciudadanos', type: 'link' },
				{ path: '/users/neighborhood', title: 'Jefes de manzana', type: 'link' },
				{ path: '/users/officers', title: 'Enlace', type: 'link' },
				{ path: '/users/supervisors', title: 'Supervisores', type: 'link' },
				{ path: '/users/admins', title: 'Administradores', type: 'link' },
			]
		},
		{
			title: 'Catálogos', icon: 'list', type: 'sub', active: false, children: [
				{ path: '/catalogs/areas', title: 'Áreas', type: 'link' },
				// { path: '/catalogs/services', title: 'Servicios', type: 'link' },
				// { path: '/catalogs/formalities', title: 'Trámites', type: 'link'},
				// { path: '/catalogs/sources', title: 'Fuentes', type: 'link' },
				// { path: '/catalogs/users', title: 'Perfiles', type: 'link' },
				{ path: '/catalogs/reportes', title: 'Reportes', type: 'link' },
			]
		},
		/*{
			title: 'Viajes', path: '/trips', icon: 'navigation-2', type: 'link', badgeType: 'primary', active: false
		}*/		
	]
	itemsSuperAdmin = new BehaviorSubject<Menu[]>(this.MENUSUPERADMIN);

	/**
	 * Mapa estático: permissionKey → ítem de menú (path + estructura)
	 * Permite filtrar MENUITEMS por permisos sin reescribir toda la estructura.
	 * Los menús sub (type: 'sub') se incluyen si al menos un hijo es visible.
	 */
	private PERMISSION_KEY_MAP: { key: string; path?: string }[] = [
		{ key: 'dashboard',                 path: '/dashboard'                   },
		{ key: 'ciudadanos',                path: '/users'                        },
		{ key: 'reportes',                                                         },
		{ key: 'reportes.nuevo',            path: '/reportes/nuevo'               },
		{ key: 'reportes.turnados',         path: '/reports'                      },
		{ key: 'reportes.sin_turnar',       path: '/reports/not-assigned'        },
		{ key: 'reportes.mapa',             path: '/reports/mapa'                 },
		{ key: 'estadisticas',                                                     },
		{ key: 'estadisticas.general',      path: '/reports/general'              },
		{ key: 'estadisticas.area',         path: '/reports/area'                 },
		{ key: 'estadisticas.fuente',       path: '/reports/fuente'               },
		{ key: 'estadisticas.ciudadano',    path: '/reports/ciudadano'            },
		{ key: 'estadisticas.colonia',      path: '/reports/colonia'              },
		{ key: 'tramites',                                                         },
		{ key: 'tramites.configuracion',    path: '/tramites/configuracion'   },
		{ key: 'tramites.catalogo',       path: '/tramites/catalogo'      },
		{ key: 'tramites.solicitudes',    path: '/tramites/solicitudes'   },
		{ key: 'bolsatrabajo',                                                     },
		{ key: 'bolsatrabajo.empresas',     path: '/jobs/companies'               },
		{ key: 'bolsatrabajo.vacantes',     path: '/jobs'                         },
		{ key: 'limpiapublica',                                                    },
	{ key: 'limpiapublica.dashboard',      path: '/limpia-publica/dashboard'      },
	{ key: 'limpiapublica.monitoreo',      path: '/limpia-publica/monitor'        },
	{ key: 'limpiapublica.unidades',       path: '/limpia-publica/unidades'       },
	{ key: 'limpiapublica.rutas',          path: '/limpia-publica/rutas'          },
	{ key: 'limpiapublica.turnos',         path: '/limpia-publica/turnos'         },
	{ key: 'limpiapublica.suscripciones',  path: '/limpia-publica/suscripciones'  },
	{ key: 'limpiapublica.programacion',   path: '/limpia-publica/programacion'   },
	{ key: 'limpiapublica.bitacora',       path: '/limpia-publica/bitacora'       },
	{ key: 'limpiapublica.notificaciones', path: '/limpia-publica/notificaciones' },
	// limpiapublica.configuracion no está en el mapa → siempre visible (hasAccess devuelve true)
		{ key: 'catalogos',                                                        },
	{ key: 'catalogos.dependencias',    path: '/catalogs/dependencias'        },
	{ key: 'catalogos.tiposdoc',        path: '/catalogs/tipos-documento'     },
	{ key: 'catalogos.scian',           path: '/catalogs/codigos-scian'       },
	{ key: 'catalogos.reportes',        path: '/catalogs/reportes'            },
		{ key: 'catalogos.turnos',          path: '/catalogs/turnos'              },
		{ key: 'formularios',                                                      },
		{ key: 'formularios.lista',       path: '/formularios/lista'             },
		{ key: 'seguridad',                                                        },
		{ key: 'seguridad.areas',           path: '/seguridad/areas'              },
		{ key: 'seguridad.perfiles',        path: '/seguridad/perfiles'           },
		{ key: 'seguridad.modulos',         path: '/seguridad/modulos'            },
		{ key: 'seguridad.usuarios',        path: '/seguridad/usuarios'           },
		{ key: 'sistema',                                                          },
		{ key: 'sistema.variables',         path: '/sistema/variables'            },
		{ key: 'sistema.integraciones',     path: '/sistema/integraciones-pago'   },
		{ key: 'sistema.configuracion',     path: '/sistema/configuracion'        },
	];

	/**
	 * Filtra el árbol de menú estático dejando solo los ítems que el usuario
	 * tiene permiso de ver (can_view === true).
	 * Si no hay permisos definidos, devuelve el menú completo (compatibilidad).
	 */
	public buildMenuFromPermissions(
		baseMenu: Menu[],
		permissionsMap: Record<string, any>
	): Menu[] {
		if (!permissionsMap || Object.keys(permissionsMap).length === 0) {
			return baseMenu;
		}

		const hasAccess = (path: string): boolean => {
			if (!path) return true;
			const entry = this.PERMISSION_KEY_MAP.find(e => e.path === path);
			if (!entry) return true;
			return permissionsMap[entry.key]?.can_view === true;
		};

		const filtered: Menu[] = [];
		for (const item of baseMenu) {
			if (item.type === 'label') {
				filtered.push(item);
				continue;
			}
			if (item.children && item.children.length > 0) {
				const visibleChildren = item.children.filter(c => hasAccess(c.path));
				if (visibleChildren.length > 0) {
					filtered.push({ ...item, children: visibleChildren });
				}
			} else if (hasAccess(item.path)) {
				filtered.push(item);
			}
		}

		return filtered.filter((item, idx, arr) => {
			if (item.type !== 'label') return true;
			const next = arr[idx + 1];
			return next && next.type !== 'label';
		});
	}

	/** Actualiza el BehaviorSubject items con el menú filtrado por permisos */
	public refreshMenu(permissionsMap: Record<string, any>): void {
		const filtered = this.buildMenuFromPermissions(this.MENUITEMS, permissionsMap);
		this.items.next(filtered);
	}
}
